import { useState, useEffect } from "react";
import { profileService } from "../services/profile.service";
import type { ClientProfile, UpdateProfileInput } from "@yogo/shared";

export function useProfile() {
  const [data, setData] = useState<ClientProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    profileService
      .get()
      .then((res) => setData(res.data))
      .catch(() => setError("Failed to load profile"))
      .finally(() => setLoading(false));
  }, []);

  const update = async (input: UpdateProfileInput) => {
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      const res = await profileService.update(input);
      setData(res.data);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err: unknown) {
      const e = err as { response?: { data?: { message?: string } } };
      setError(e?.response?.data?.message ?? "Update failed");
    } finally {
      setSaving(false);
    }
  };

  return { data, loading, saving, error, success, update };
}

// Day 18 complete
